const TYPE = 'em8502';
const HISTORY_SIZE = 20;

export {
	TYPE,
	HISTORY_SIZE
}
